import React from 'react';
import { createRoot } from 'react-dom/client';
import { SearchSchoolComponent } from './SearchSchoolComponent';
import $ from 'jquery';

export class SearchSchool {

  constructor() {
    this.$container = $('[data-module="searchSchool"]');
    this.schoolId = this.$container.data('school');
    this.$tabNav = $('.js-school-tab');
    this.$tabs = $('.school-page__tab');
    this.postId = this.$container.data('post-id');

    // init
    if (this.schoolId) {
      this.fetchResults();
    }

    // bind events
    this.$tabNav.on('click', e => this.openTab(e));
  }

  openTab(e) {
    const $item = $(e.currentTarget);
    const target = $item.data('target');

    // activate navigation item
    this.$tabNav.removeClass('school-page__nav-item--active');
    $item.addClass('school-page__nav-item--active');

    // active tab content
    this.$tabs.hide();
    $(target).show();
  }

  fetchResults() {
    return $.ajax({
      url: ajax_link,
      method: 'POST',
      data: {
        action: 'lyceo',
        controller: 'School',
        method: 'getTrainingsByPeriod',
        school_id: this.schoolId,
        post_id: this.postId,
        nonce: ajax_nonce,
      },
      dataType: 'json',
      success: data => this.fetchSuccess(data),
      fail: () => this.fetchFail(),
    });
  }

  fetchSuccess(data) {
    const root = createRoot($('[data-module="searchSchool"]')[0]);
    root.render(
        <>
          <SearchSchoolComponent
              trainings={data.trainings}
              post={data.post}
          />
        </>
    );
  }

  fetchFail(){}
}
